import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/login", { replace: true }); return; }
      const sessionId = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        toast.success(`Signed in as ${data.email}`);
        // clear the hash so refresh doesn't retrigger
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/admin", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Sign-in failed";
        toast.error(detail);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#0f1512] text-white flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="vp-label text-white/60 mb-2">Signing you in</div>
        <div className="font-serif-vp text-2xl">One moment…</div>
      </div>
    </div>
  );
}
